export enum DealType {
    DEAL = "DEAL",
    EVENT = "EVENT",
}


export interface Deal {
    id: string;
    content: string;
    active: boolean;
    type: DealType;
    days: string[];
    timeRanges: string[]
}

export interface NewDeal {
    content: string;
    restaurantId: string;
    days: string[];
    hours: string[];
    type: DealType;
}

export interface DealFilters {
    status: string[];
    restaurantName: string[];
    type: string[];
}
